import React from 'react';
import styled from 'styled-components';
import Box from '../../../../components/Layout/Components/Box/Box';
import BoxHeader from '../../../../components/Layout/Components/Box/Header/BoxHeader';
import BoxHeaderIcon from '../../../../components/Layout/Components/Box/Header/BoxHeaderIcon';
import ReceiptOutlinedIcon from '@material-ui/icons/ReceiptOutlined';
import LibraryBooksOutlinedIcon from '@material-ui/icons/LibraryBooksOutlined';
import TodayOutlinedIcon from '@material-ui/icons/TodayOutlined';
import { FormattedMessage } from 'react-intl';
import InfoRow from './Dashboard/InfoRow';
import OpenedTransactions from './Dashboard/OpenedTransactions';
import ClosedTransactions from './Dashboard/ClosedTransactions';
import ReservationSystem from './Dashboard/ReservationSystem';
import { useHistory, useRouteMatch } from 'react-router';
import useReduxReducer from '../../../../hooks/useReduxReducer';
import dashboard from '../../../../store/reducers/pos/dashboard';
import Button from '@material-ui/core/Button';
import PostAddIcon from '@material-ui/icons/PostAdd';
import LockOpenIcon from '@material-ui/icons/LockOpen';
import { withStyles } from '@material-ui/core/styles';
import { orange } from '@material-ui/core/colors';
import {useDispatch} from "react-redux";
import {openCashTrayAction} from "./Sale/actions";

const ColorButton = withStyles((theme) => ({
  root: {
    margin: '0 0 0 20px',
    textTransform: 'lowercase',
    color: 'white',
    backgroundColor: orange[500],
    '&:hover': {
      backgroundColor: orange[700],
    },
  },
}))(Button);

const BoxBody = styled.div`
  padding: 0 15px;
  margin-bottom: 20px;
`;

const TableBoxHeader = styled.div`
  display: flex;
  padding: 3px 15px;
  font-size: 1.5em;
`;

const Text = styled.div`
  flex: 1;
`;

const ActionIcons = styled.div`
  flex: 1;
  text-align: right;
  align-items: center;
  justify-content: center;
`;

const DashBoardRow = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const DashBoardInfoRow = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  justify-content: center;
  align-items: center;
`;

const Card = styled.div`
  flex: 1;
  padding: 0 20px 30px 20px;
`;


const Dashboard = () => {
  const history = useHistory();
  const { path } = useRouteMatch();
  const dispatch = useDispatch();

  const openDrawer = () => {
      dispatch(openCashTrayAction());
  }

  useReduxReducer({ dashboard: dashboard });

  return (
    <>
      <DashBoardInfoRow>
        <InfoRow />
      </DashBoardInfoRow>
      <DashBoardRow>
        <Card>
          <Box>
            <BoxHeader>
              <BoxHeaderIcon color={'#fb8c00'}>
                <ReceiptOutlinedIcon />
              </BoxHeaderIcon>
              <TableBoxHeader>
                <Text>
                  <FormattedMessage id={'transaction.openedTransactions'} />
                </Text>
                <ActionIcons>
                  <ColorButton
                      variant="contained"
                      color="secondary"
                      endIcon={<LockOpenIcon />}
                      onClick={openDrawer}
                  >
                    Otevřít pokladní zásuvku
                  </ColorButton>
                  <ColorButton
                    variant="contained"
                    color="secondary"
                    endIcon={<PostAddIcon />}
                    onClick={() => {
                      history.push(`${path}/sale/`);
                    }}
                  >
                    <FormattedMessage id={'transaction.new'} />
                  </ColorButton>
                </ActionIcons>
              </TableBoxHeader>

            </BoxHeader>
            <BoxBody style={{ padding: '0px 15px' }}>
              <OpenedTransactions />
            </BoxBody>
          </Box>
        </Card>
      </DashBoardRow>
      <DashBoardRow>
        <Card>
          <Box>
            <BoxHeader>
              <BoxHeaderIcon color={'#00acc1'}>
                <LibraryBooksOutlinedIcon />
              </BoxHeaderIcon>
              <TableBoxHeader>
                <FormattedMessage id={'transaction.reservationSystem'} />
              </TableBoxHeader>
            </BoxHeader>
            <BoxBody style={{ padding: '0px 15px' }}>
              <ReservationSystem />
            </BoxBody>
          </Box>
        </Card>
      </DashBoardRow>
      <DashBoardRow>
        <Card>
          <Box>
            <BoxHeader>
              <BoxHeaderIcon color={'#43a047'}>
                <TodayOutlinedIcon />
              </BoxHeaderIcon>
              <TableBoxHeader>
                <FormattedMessage id={'transaction.closedTransactions'} />
              </TableBoxHeader>
            </BoxHeader>
            <BoxBody style={{ padding: '0px 15px' }}>
              <ClosedTransactions />
            </BoxBody>
          </Box>
        </Card>
      </DashBoardRow>
    </>
  );
};

export default Dashboard;
